import { ReadingsState } from '@/models/states/readings-state.model';

export const state: ReadingsState = {
  station: '',
  data: [],
};
